import modalIcon from "../../theme1/assets/icons/warning-2@3x.png";
var modalData = {
  name: 'modal',
  data: [{
    showBgIcon: false,
    // 是否显示背景图标
    wrapBgColor: 'white',
    iconWidth: 18,
    iconHeight: 18,
    fontFamily: 'PingFangSC-Medium',
    fontSize: 14,
    titleColor: 'rgba(0,0,0,0.85)',
    descriptionColor: '#333333',
    iconImage: modalIcon,
    contentFont: 'PingFangSC-Regular',
    width: 350,
    paddingLeftAndRight: 48,
    // titlePaddingLeft: 20,
    footColor: 'white',
    footerBorder: 'none',
    footerBorderRadius: 14,
    footerFontSize: 12,
    footFontPadding: '0 0.16rem',
    // wrapBoxShadow: "0 4px 12px 0 rgba(0,0,0,0.20)",
    wrapBorderRadius: 2,
    closeBtnTop: 21,
    closeBtnRight: 16,
    headerPadding: '20px 16px 12px',
    bodyPadding: 16,
    footerPadding: '16px'
  }]
};
export default modalData;